import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Gider modülü olayları. Yükler KİŞİSEL VERİ TAŞIMAZ (açıklama, cari adı, kart sahibi yok): kiracıdaki tüm
 * oturumlara gidebilirler; istemci ayrıntıyı yetki denetimli `/expenses/:id` ucundan çeker.
 */
export const expenseSubmittedV1 = defineEvent({
    type: "expenses.expense.submitted",
    version: 1,
    description: "Gider onaya gönderildi (politika yoksa aynı anda onaylanır)",
    realtime: ["tenant"],
    payload: z.object({
        expenseId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid().nullable(),
        categoryId: z.uuid(),
        /** Kuruş (dizge): matrah + KDV. */
        grossAmount: z.string(),
        paymentMethod: z.enum(["CASH", "BANK", "COMPANY_CARD", "ON_ACCOUNT"]),
        approvalStatus: z.enum(["PENDING", "AUTO_APPROVED"]),
        approvalRequestId: z.uuid(),
    }),
});
export const expenseApprovedV1 = defineEvent({
    type: "expenses.expense.approved",
    version: 1,
    description: "Gider onaylandı: numara verildi, paylar donduruldu ve fiş kesildi",
    realtime: ["tenant"],
    payload: z.object({
        expenseId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid().nullable(),
        expenseNo: z.string(),
        docDate: z.iso.date(),
        dueDate: z.iso.date(),
        /** Kuruş (dizge): matrah + KDV − stopaj. */
        payableAmount: z.string(),
        paymentMethod: z.enum(["CASH", "BANK", "COMPANY_CARD", "ON_ACCOUNT"]),
        ledgerStatus: z.enum(["NONE", "POSTED", "QUEUED", "REVERSED"]),
        allocationCount: z.number().int(),
    }),
});
export const expenseCancelledV1 = defineEvent({
    type: "expenses.expense.cancelled",
    version: 1,
    description: "Gider iptal edildi (onaylanmışsa fişin ters kaydı alındı)",
    realtime: ["tenant"],
    payload: z.object({
        expenseId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid().nullable(),
        expenseNo: z.string().nullable(),
        /** İptalden önceki durum. */
        previousStatus: z.enum(["DRAFT", "PENDING_APPROVAL", "APPROVED"]),
    }),
});
export const recurringExpenseGeneratedV1 = defineEvent({
    type: "expenses.recurring.generated",
    version: 1,
    description: "Tekrarlayan gider tanımından bir dönemin taslağı üretildi ve onaya gönderildi",
    realtime: ["tenant"],
    payload: z.object({
        recurringExpenseId: z.uuid(),
        expenseId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid().nullable(),
        periodKey: z.string(),
        dueDate: z.iso.date(),
        /** Kuruş (dizge): matrah. */
        netAmount: z.string(),
    }),
});
//# sourceMappingURL=expenses.v1.js.map